<template>
  <div>
	  <template v-if="headerShow">
		  <svg id="map" width="800" height="600"></svg>
	  </template>
	  <template v-else>
		  <svg id="map" style="width: 100%;" height="600"></svg>
	  </template>
  </div>
</template>

<script>
import * as d3 from 'd3';
import * as topojson from 'topojson';
import jsonData from '@/assets/world-110m.json';
export default {
  data() {
    return {
      mapData: null
    }
  },
  mounted() {
	  this.mapData = jsonData;
	  this.drawMap();
   // d3.json('world-110m.json').then(data => {
   //       this.mapData = data;
   //       this.drawMap();
   //     });
 //    d3.json(jsonData).then(res=>{
	// 	console.log(res)
	// }).catch(err=>{
	// 	console.log(err)
	// })
	// .then(geojson => {
	// 	console.log(geojson)
 //      // svg.append("g")
 //      //   .selectAll("path")
 //      //   .data(geojson.features)
 //      //   .enter()
 //      //   .append("path")
 //      //   .attr("d", path)
 //      //   .on("click", (event, d) => {
 //      //     const [x, y] = this.projection.invert(d3.pointer(event));
 //      //     console.log(`Clicked on (${x}, ${y})`);

 //      //     const rotate = this.projection.rotate();
 //      //     this.rotation = [-x, -y, -rotate[2]];
 //      //     this.projection.rotate(this.rotation);
 //      //     svg.selectAll("path").attr("d", path);
 //      //   });
 //    });
  },
  methods: {
      drawMap() {
        const svg = d3.select('#map');
  
        const projection = d3.geoMercator()
          .scale(130)
          .translate([svg.attr('width') / 2, svg.attr('height') / 1.5]);
  
        const path = d3.geoPath().projection(projection);
  
        svg.selectAll('path')
          .data(topojson.feature(this.mapData, this.mapData.objects.countries).features)
          .enter().append('path')
          .attr('d', path)
          .style('fill', '#ccc')
          .style('stroke', '#333');
		  
			setTimeout(() => {
			  projection.rotate([90, 0]);
			  svg.selectAll('path').transition().duration(2000).attr('d', path);
			}, 2000);
      }
	  
    }
}
</script>
<style scoped lang="scss">
</style>